"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createStyled = require("../../../utils/createStyled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _border = _interopRequireDefault(require("../style/border"));

var Border = function Border(props) {
  var styles = (0, _border["default"])(props);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_createStyled.Styled.Hr, {
    styles: styles.passive
  }), _react["default"].createElement(_createStyled.Styled.Hr, {
    styles: styles.active
  }));
};

Border.propTypes = {
  theme: _propTypes["default"].object
};
var _default = Border;
exports["default"] = _default;